export const FOOTBALL_HEADER_COPY = {
  eyebrow: 'Sports Hub • Football',
  title: 'Football Terminal',
  description: 'Track live games, tables, and top players from football leagues worldwide.'
};
